import client from "@client";
import { formatOriginUrl } from "@utils/formatters";

export const env = import.meta.env;

/**
 * Bundler flags
 */
export const isProduction = env.PROD;
export const isDevelopment = env.DEV;
export const envMode = env.MODE;

/**
 * Client identifier
 */
export const clientId = env.VITE_CLIENT_ID;

/**
 * Application version set in the package.json
 */
export const appVersion = env.VITE_APP_VERSION;

/**
 * Backend api url
 */
export const apiUrlOriginacaoDefault = env.VITE_API_URL_ORIGINACAO;
export const apiUrlOriginacaoV2 = env.VITE_API_URL_ORIGINACAO_V2;

function getApiUrlOriginacao() {
  const urlParams = new URLSearchParams(window.location.search);
  const apiUrlParam = urlParams.get("apiUrl");

  if (env.MODE === "production") return apiUrlOriginacaoDefault;

  if (apiUrlParam === "v2") {
    localStorage.setItem("apiUrlOriginacao", "v2");
    return apiUrlOriginacaoV2;
  } else if (apiUrlParam === "v1") {
    localStorage.removeItem("apiUrlOriginacao");
    return apiUrlOriginacaoDefault;
  }

  const storedApiUrl = localStorage.getItem("apiUrlOriginacao");

  if (storedApiUrl === "v2") {
    return apiUrlOriginacaoV2;
  } else {
    return apiUrlOriginacaoDefault;
  }
}

export const apiUrlOriginacao = getApiUrlOriginacao();

/**
 * AWS api url
 */
export const apiUrlAws = env.VITE_API_VALID_IMAGE_URL;

/**
 * Backend websocket url
 */
export const apiUrlOriginacaoWs = env.VITE_API_URL_ORIGINACAO_WS;

/**
 * New Relic settings
 */
export const newRelic = {
  applicationId: env.VITE_NEW_RELIC_APPLICATION_ID,
  licenceKey: env.VITE_NEW_RELIC_LICENSE_KEY,
  accountId: env.VITE_NEW_RELIC_ACCOUNT_ID,
} as const;

/**
 * Smartlook client key
 */
export const smartlookClientKey = env.VITE_SMARTLOOK_CLIENT_KEY;

/**
 * Clarity client key
 */
export const clarityClientKey = env.VITE_CLARITY_CLIENT_KEY;

/**
 * DataDog settings
 */
export const dataDog = {
  applicationId: env.VITE_DATA_DOG_APPLICATION_ID,
  clientToken: env.VITE_DATA_DOG_CLIENT_TOKEN,
  serviceName: env.VITE_DATA_DOG_SERVICE_NAME,
};

/**
 * Firebase settings
 */
export const firebaseConfig = {
  apiKey: env.VITE_FIREBASE_API_KEY,
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: env.VITE_FIREBASE_APP_ID,
  measurementId: env.VITE_FIREBASE_MEASUREMENT_ID,
};

/**
 * Cognito settings
 */
export const cognitoConfig = {
  userPoolId: env.VITE_USER_POOL_ID,
  userPoolClientId: env.VITE_USER_POOL_CLIENT_ID,
};

/**
 * Main URL
 */
export const mainUrl = formatOriginUrl(env.VITE_MAIN_URL);

/**
 * Card exclusive URL
 */
export const cardExclusiveUrl = formatOriginUrl(env.VITE_CARD_EXCLUSIVE_URL);

/**
 * Enable API mocks
 */
export const enableApiMocks = env.VITE_ENABLE_API_MOCKS === "1";

/**
 * Static Client Settings with apiKeys object set from environment variables
 */
export const clientSettings: ClientSettingsWithKeys = {
  ...client,
  apiKeys: {
    newRelic: newRelic,
    smartlook: {
      clientKey: smartlookClientKey,
    },
    clarity: {
      clientKey: clarityClientKey,
    },
    dataDog: {
      applicationId: dataDog.applicationId,
      clientToken: dataDog.clientToken,
      serviceName: dataDog.serviceName,
    },
  },
};
